// This icon needs to dynamically change based on the number of uncompleted action items currently assigned to you

import { Relations } from "@inrev/common";
import { useFetchAdminActionItemsForRelation } from "@portal/api/action-item/admin";
import { ToolIcon } from "@portal/components/ui/ToolIcon";
import { MdChecklist } from "react-icons/md";

export const AdminActionItemIcon = ({ relation, ...rest }: { relation: Relations.ActionItems }) => {
	const { actionItems } = useFetchAdminActionItemsForRelation(relation);

	const uncompletedActionItems = Object.values(actionItems).filter(
		(actionItem) => !actionItem.completedAt,
	).length;

	return (
		<ToolIcon
			icon={<MdChecklist />}
			label="Action Items"
			notifications={{ count: uncompletedActionItems, color: "red" }}
			{...rest}
		/>
	);
};
